/* Epilekton load-more — appends next page products without full reload */
(function () {
  'use strict';

  var btn = document.querySelector('[data-load-more]');
  if (!btn) return;

  btn.addEventListener('click', function () {
    var nextUrl = btn.dataset.nextUrl;
    if (!nextUrl || btn.disabled) return;

    btn.disabled = true;
    btn.setAttribute('aria-busy', 'true');

    var originalText = btn.textContent.trim();
    btn.textContent = '...';

    fetch(nextUrl)
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');

        // Extract new product items from the next page's grid
        var newItems = doc.querySelectorAll('#product-grid .epi-product-grid__item');
        var grid = document.querySelector('#product-grid');

        if (grid && newItems.length) {
          newItems.forEach(function (item) {
            grid.appendChild(document.adoptNode(item));
          });
        }

        // Update the button with the next-next page URL, or hide if none
        var nextBtn = doc.querySelector('[data-load-more]');
        if (nextBtn) {
          btn.dataset.nextUrl = nextBtn.dataset.nextUrl;
          btn.disabled = false;
          btn.removeAttribute('aria-busy');
          btn.textContent = originalText;
        } else {
          // No more pages
          var loadMoreWrap = document.getElementById('epi-load-more');
          if (loadMoreWrap) loadMoreWrap.hidden = true;
        }

        // Update product count display
        var newCount = doc.querySelector('#epi-product-count');
        var count = document.querySelector('#epi-product-count');
        if (newCount && count) count.textContent = newCount.textContent;
      })
      .catch(function (err) {
        console.warn('[epi-load-more] fetch error', err);
        btn.disabled = false;
        btn.removeAttribute('aria-busy');
        btn.textContent = originalText;
      });
  });
})();
